import React from 'react'
import './CardRapport.css'

const CardRapport = ({el}) => {
  return (
    <div className="rapport-card">
      <div className="rapport-card-header">
        <span className="rapport-location"><i className="fas fa-map-marker-alt"></i> {el.localisation}</span>
        <span className="rapport-date">{new Date(el.DateCollect).toLocaleDateString('fr-FR')}</span>
      </div>
      <div className="rapport-card-body">
        <div className="rapport-stat">
          <span className="rapport-label">Total Amount</span>
          <span className="rapport-value success">{el.TotalAmount || el.Amount || 0} TND</span>
        </div>
        <div className="rapport-stat">
          <span className="rapport-label">Expenses</span>
          <span className="rapport-value danger">{el.MonthExpenses || el.DailyExpenses || 0} TND</span>
        </div>
        <div className="rapport-stat highlight-stat">
          <span className="rapport-label">Net</span>
          <span className="rapport-value">{(el.TotalAmount || el.Amount || 0) - (el.MonthExpenses || el.DailyExpenses || 0)} TND</span>
        </div>
      </div>
      {el.feedback && (
        <div className="rapport-card-footer">
          <span className="feedback-label">Feedback:</span>
          <p>{el.feedback}</p>
        </div>
      )}
    </div>
  )
}

export default CardRapport
